import { useEffect, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { getCanonicalAuthUrl } from "@/lib/auth-origin";

export default function AuthOriginGuard({ children }: { children: ReactNode }) {
  const location = useLocation();
  const canonicalUrl = getCanonicalAuthUrl(new URL(
    `${location.pathname}${location.search}${location.hash}`,
    window.location.origin,
  ));

  useEffect(() => {
    if (canonicalUrl) window.location.replace(canonicalUrl);
  }, [canonicalUrl]);

  // Cover SPA navigation as well as the initial requests handled by Vercel.
  // Do not mount an auth form until it can store the verifier on the right origin.
  return canonicalUrl ? <p role="status" className="p-6 text-zinc-300">Opening secure sign-in…</p> : children;
}
